import React from 'react';
import logoLogin from '../../assets/images/logo-login.svg';
import s from './LogoAndTitle.module.scss';

const LogoAndTitle = () => {
  return (
    <>
      <div className={s['logo-and-title']}>
        <div className={s['logo-and-title__section']}>
          <img src={logoLogin} alt="company-logo" />
        </div>
        <div className={s['logo-and-title__section__logo-subtitle']}>
          Sustainable Ad Manager - Intelligent (SAM-i)
        </div>
      </div>
    </>
  );
};

export default LogoAndTitle;
